import 'ress';
import '../styles/index.scss';

import {
  AppManager,
  SoundManager,
  appConfig,
  AnalyticsManager,
} from '@common';
import loadExternalConfigs from './config/loadExternalConfigs';
import WelcomeScreen from './components/WelcomeScreen';


const initApp = async () => {
  // preinit
  AppManager.setLoading(true);
  await SoundManager.load();
  const panoramaJson = await loadExternalConfigs();
  await AppManager.preinit(panoramaJson);
    
  if (appConfig.welcomeScreenEnabled) {
    const welcome = WelcomeScreen.add();
    AnalyticsManager.sendWelcome();
    AppManager.setLoading(false);
    await welcome.waitForTap();
    AppManager.init();
    SoundManager.playBGM('present');
    welcome.remove();
  } else {
    AppManager.setLoading(false);
    SoundManager.playBGM('present');
    AppManager.init();
  }
  // if (appConfig.cookieConsentEnabled) {
  //   CookieConsent.init();
  // }
};
initApp();